export const genericMessage = {
  added: "Added successfully.",
  saved: "Saved successfully.",
  updated: "Updated successfully!",
  deleted: "Deleted successfully!",
  deletedUser: "Delete Request Initated!",
  documentDeleted: "Document deleted successfully",
  subcriptionChanged: "Subcription changed sucessfully!",
  subscriptionCancelled: "Subscription Plan cancelled sucessfully!",
  cardDefault: "Card set as default!",
  defaultCardErr: "Default Card can't be deleted",
  cardAlreadySetErr: "Card can't set as default it is already default",
  logusercantdeleted: "Logged in user can't be deleted!.",
  notAuth: "You are not authorized. Please contact to Admnistrator!",
  availableCredit: "Available credit and insufficient",
  recieverAddressErr: "Please select or add receiver address!",
  senderAddressErr: "Please select or add sender address!",
  selectCustomer: "Please select Customer",
  paymentSuccess: "Payment successfull!",
  acceptConditions: "Please accept Terms and Conditions & Privacy Policy",
  otpValidate: "OTP valideate successfully!",
  paswordSetSuccess: "Password successfully!",
  dataExportedSucces: "Data exported successfully in CSV format !",
  samePassword: "New Password and confirm password should be same.",
  passwordUpdate: "Password updated successfully.",
  enterDocumentName: "Please enter Document Name",
  imgDimensionErr: "Image dimensions must be at least 170x170.",
  noItemBeforeEmail: "Please select the Item(s) before sending the email.",
  notAllowed: "Please upgrade your plan to access this feature",
  noCreditAvailableTitle: "No Credit Available for feature access",
  billingMsg: "Click below to upgrade plan in Billing section.",
  noSelectedTheme: "Please select theme first.",
  planDefaultRolecantdeleted: "Default role can't be deleted.",
  invalidABN: "Please enter valid ABN.",
  deleteUser: "Deleted successfully.",
  notPermission:
    "You are not authorized to access this screen. Please contact your administrator for assistance.",
  noRecordFound: "Record Not Found",
};
